// Хард-ресет приложения для pull-to-refresh.
//
// Что делаем (и почему):
//   1. update() на каждой SW-регистрации — заставляем браузер проверить наличие
//      новой версии воркера прямо сейчас, не дожидаясь фонового цикла.
//   2. unregister() — снимаем воркер, чтобы следующая загрузка перерегистрировала
//      его с нуля (vite-plugin-pwa, registerType: 'autoUpdate', сделает это сам).
//   3. Чистим Cache Storage целиком: precache app-shell (JS/CSS/HTML/иконки) +
//      runtime-кэши данных (isaac-db / isaac-sprites / isaac-data). После reload
//      всё подтянется из сети заново.
//
// БД в OPFS НЕ трогаем: воркер сам сверяет user_version с manifest.json и
// перекачивает items.sqlite только при реальном обновлении данных — нет смысла
// форсить ~2.5 МБ скачивания на каждый pull.
export async function hardReset(): Promise<void> {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(
        regs.map(async (r) => {
          try { await r.update(); } catch { /* офлайн / нет сети — не критично */ }
          await r.unregister();
        }),
      );
    }
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch (e) {
    console.warn('[hard-reset] очистка не удалась, перезагружаемся как есть', e);
  } finally {
    location.reload();
  }
}
